<template lang="html">
<div>
  <Nav></Nav>
  <div class="section">
    <b-field label="Show traces by">
      <b-select placeholder="Select a name"
                v-model="selectedUser">
        <option
          v-for="user in users"
          :value="user.id"
          :key="user.id">
          {{ user.short_name }}
        </option>
      </b-select>
    </b-field>
    <TraceTable v-bind:user_id="selectedUser"
                v-bind:editable="false"
                v-bind:showUser="false">
    </TraceTable>
  </div>
</div>
</template>

<script>
import Nav from '@/components/Nav'
import TraceTable from '@/components/TraceTable'
import User from '@/models/User'
import api from '@/utils/api'

export default {
  name: 'Home',
  components: {
    Nav,
    TraceTable
  },
  data () {
    return {
      // Initialise directly from store, this is initialised before
      // computed getters.
      selectedUser: this.$store.state.auth.id
    }
  },
  computed: {
    users () {
      return User.query().get()
    }
  },
  mounted () {
    // Load all users from backend.
    api.getUsers()
      .catch((response) => {
        api.showApiErrorDialog(
          this, response)
      })
  },
  watch: {
    selectedUser (user) {
      // Lazy load traces for each user when selected.
      api.getTraces(user)
        .catch((response) => {
          api.showApiErrorDialog(
            this,
            response,
            `Unable to load new traces for user ${this.selectedUser}`
          )
        })
    }
  }
}
</script>
